import { Component, Input } from '@angular/core';
import { TextMessageResponse } from '../../../models/responses/text-message-response';
import { TextConversationResponse } from '../../../models/responses/text-conversation-response';
import { MessageRole } from '../../../models/enums/message-role';
import { TextMessageService } from '../../../services/text-message.service';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { Clipboard } from '@angular/cdk/clipboard';

const AGENT_ID_KEY = "{{AGENTID}}"
const CHATBOT_CODE = `
<app-question-box style="position:fixed;bottom:0;right:0;" aiAgentId=${AGENT_ID_KEY}
    logo="{{LOGO_URL_HERE}}"></app-question-box>

<script type="text/javascript"
    src="https://cdn.jsdelivr.net/gh/momolakeit/AiAssistantEmbedded/embeddedchatbot.js   "></script>
<link rel="stylesheet" href="https://cdn.jsdelivr.net/gh/momolakeit/AiAssistantEmbedded@latest/styles.css" />
<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">`;

@Component({
  selector: 'app-chatbot',
  standalone: true,
  imports: [
    MatIconModule,
    NgIf,
    NgFor,
    FormsModule,
    CommonModule,
    MatButtonModule
  ],
  templateUrl: './chatbot.component.html',
  styleUrl: './chatbot.component.scss'
})
export class ChatbotComponent {

  namespace: string = "";
  logo: string = "https://i.ibb.co/VHGJjZz/kitty-Logo.png"
  inAction: boolean = false;
  query: string = "";
  textAnswer: string = "";
  isLoading: boolean = false;
  images: string[] = [];
  textConversationId: number = -1;
  @Input() aiAgentId!: number;
  messages: TextMessageResponse[] = [];

  constructor(
    private textMessageService: TextMessageService,
    private clipboard: Clipboard
  ) {

  }

  ngOnInit(): void {
    this.initConversation();
  }

  initConversation() {
    this.messages = [];
    this.textMessageService.initConversation(this.aiAgentId).subscribe(data => {
      this.textConversationCallback(data);
    });
  }

  changeFormat() {
    this.inAction = !this.inAction;
  }

  answer() {
    let userQuery = this.query;
    this.query = "";
    this.isLoading = true;
    setTimeout(this.scrollChatLog, 10);

    if (userQuery) {
      this.messages.push({ content: userQuery, id: -1, role: MessageRole.User, textConversationId: -1 })
      this.textMessageService.sendMessage({ query: userQuery, textConversationId: this.textConversationId }).subscribe(data => {
        this.textConversationCallback(data);
      });
    }
  }

  scrollChatLog(): void {
    let chatLog = document.getElementsByClassName("chat-log")[0];

    if (chatLog)
      chatLog.scrollTop = chatLog.scrollHeight;
  }

  copyChatbotCode() {
    this.clipboard.copy(CHATBOT_CODE.replace(AGENT_ID_KEY, this.aiAgentId.toString()));
  }

  private textConversationCallback(data: TextConversationResponse) {
    this.textConversationId = data.id;
    this.isLoading = false;
    this.messages = data.textMessages;
    setTimeout(this.scrollChatLog, 10);
  }
}
